module.exports = __webpack_public_path__ + "assets/media/defaultEmpty.304ccfc8.svg";